import React, { useState } from 'react';
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import ApprovalOrdersTable from "./components/ApprovalOrdersTable";
import ApprovalOrderDialog from "./components/ApprovalOrderDialog";
import ApprovalOrdersFilter from "./components/ApprovalOrdersFilter";
import { useApprovalOrders } from "./hooks/useApprovalOrders";
import { useLanguage } from "../../contexts/LanguageContext";

const ApprovalOrdersPage = () => {
    const { th } = useLanguage();

    const {
        selectedTab,
        setSelectedTab,
        orders,
        isLoading,
        refetch,
        isParentDealer,
        filterFields,
        handleApplyFilters,
        handleResetFilters
    } = useApprovalOrders();

    const [selectedOrder, setSelectedOrder] = useState(null);

    const tabItems = [
        {
            key: 20, label: (
                <>
                    <i className="pi pi-clock mr-2"></i>
                    {th("approvalOrders.tabs.waitingApproval")}
                </>
            )
        },
        {
            key: 30, label: (
                <>
                    <i className="pi pi-check-circle mr-2"></i>
                    {th("approvalOrders.tabs.approved")}
                </>
            )
        },
        {
            key: 25, label: (
                <>
                    <i className="pi pi-times-circle mr-2"></i>
                    {th("approvalOrders.tabs.rejected")}
                </>
            )
        },
    ];

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>{th("approvalOrders.title")}</h3>
                <Button icon="pi pi-refresh" label={th("common.refreshList")} onClick={refetch} />
            </div>

            <ApprovalOrdersFilter
                filterFields={filterFields}
                handleApplyFilters={handleApplyFilters}
                handleResetFilters={handleResetFilters}
            />

            <TabView
                activeIndex={tabItems.findIndex((t) => t.key === selectedTab)}
                onTabChange={(e) => setSelectedTab(tabItems[e.index].key)}
            >
                {tabItems.map((tab) => (
                    <TabPanel key={tab.key} header={tab.label}>
                        <ApprovalOrdersTable
                            data={orders ?? []}
                            isLoading={isLoading}
                            onView={(order) => setSelectedOrder(order)}
                        />
                    </TabPanel>
                ))}
            </TabView>

            {selectedOrder && (
                <ApprovalOrderDialog
                    visible={!!selectedOrder}
                    order={selectedOrder}
                    onHide={() => setSelectedOrder(null)}
                    onUpdated={refetch}
                    isParentDealer={isParentDealer}
                    selectedTab={selectedTab}
                />
            )}
        </div>
    );
};

export default ApprovalOrdersPage;
